module.exports = __webpack_public_path__ + "static/media/icon_v.a1d258a4.svg";